export const BANKS: any =  [{
    "stateName": "Andhra Pradesh",
    "districtName": [
        "Adilabad",
        "Anantapur",
        "Chittoor",
        'East Godavari',
        "Kakinada",
        "Guntur",
        "Hyderabad",
        "Karimnagar",
        "Khammam",
        "Krishna",
        "Kurnool",
        "Mahbubnagar",
        "Medak",
        "Nalgonda",
        "Nizamabad",
        "Ongole",
        "Srikakulam",
        "Nellore",
        "Visakhapatnam",
        "Vizianagaram",
        "Warangal",
        "Eluru",
        "Kadapa"
    ]
}, {
    "stateName": "Arunachal Pradesh",
    "districtName": [
        "Anjaw",
        "Changlang",
        "East Siang",
        "Kurung Kumey",
        "Lohit",
        "Lower Dibang Valley",
        "Lower Subansiri",
        "Papum Pare",
        "Tawang",
        "Tirap",
        "Dibang Valley",
        "Upper Siang",
        "Upper Subansiri",
        "West Kameng",
        "West Siang"
    ]
},
{
    "stateName": "Assam",
    "districtName": [
        "Baksa",
        "Barpeta",
        "Bongaigaon",
        "Cachar",
        "Chirang",
        "Darrang",
        "Dhemaji",
        "Dima Hasao",
        "Dhubri",
        "Dibrugarh",
        "Goalpara",
        "Golaghat",
        "Hailakandi",
        "Jorhat",
        "Kamrup",
        "Kamrup Metropolitan",
        "Karbi Anglong",
        "Karimganj",
        "Kokrajhar",
        "Lakhimpur",
        "Marigaon",
        "Nagaon",
        "Nalbari",
        "Sibsagar",
        "Sonitpur",
        "Tinsukia",
        "Udalguri"
    ]
},

{
    "stateName": "Bihar",
    "districtName": [
        "Araria",
        "Arwal",
        "Aurangabad",
        "Banka",
        "Begusarai",
        "Bhagalpur",
        "Bhojpur",
        "Buxar",
        "Darbhanga",
        "East Champaran",
        "Gaya",
        "Gopalganj",
        "Jamui",
        "Jehanabad",
        "Kaimur",
        "Katihar",
        "Khagaria",
        "Kishanganj",
        "Lakhisarai",
        "Madhepura",
        "Madhubani",
        "Munger",
        "Muzaffarpur",
        "Nalanda",
        "Nawada",
        "Patna",
        "Purnia",
        "Rohtas",
        "Saharsa",
        "Samastipur",
        "Saran",
        "Sheikhpura",
        "Sheohar",
        "Sitamarhi",
        "Siwan",
        "Supaul",
        "Vaishali",
        "West Champaran",
        "Chandigarh"
    ]
},
{
    "stateName": "Chhattisgarh",
    "districtName": [
        "Bastar",
        "Bijapur",
        "Bilaspur",
        "Dantewada",
        "Dhamtari",
        "Durg",
        "Jashpur",
        "Janjgir-Champa",
        "Korba",
        "Koriya",
        "Kanker",
        "Kabirdham (Kawardha)",
        "Mahasamund",
        "Narayanpur",
        "Raigarh",
        "Rajnandgaon",
        "Raipur",
        "Surguja"
    ]
}, {
    "stateName": "Dadra and Nagar Haveli",
    "districtName": [
        "Dadra and Nagar Haveli"
    ]
},

{
    "stateName": "Daman and Diu",
    "districtName": [
        "Daman",
        "Diu"
    ]
},
{
    "stateName": "Delhi",
    "districtName": [
        "Central Delhi",
        "East Delhi",
        "New Delhi",
        "North Delhi",
        "North East Delhi",
        "North West Delhi",
        "South Delhi",
        "South West Delhi",
        "West Delhi"
    ]
},
{
    "stateName": "Goa",
    "districtName": [
        "North Goa",
        "South Goa"
    ]
},
{
    "stateName": "Gujarat",
    "districtName": [
        "Ahmedabad",
        "Amreli district",
        "Anand",
        "Banaskantha",
        "Bharuch",
        "Bhavnagar",
        "Dahod",
        "The Dangs",
        "Gandhinagar",
        "Jamnagar",
        "Junagadh",
        "Kutch",
        "Kheda",
        "Mehsana",
        "Narmada",
        "Navsari",
        "Patan",
        "Panchmahal",
        "Porbandar",
        "Rajkot",
        "Sabarkantha",
        "Surendranagar",
        "Surat",
        "Vyara",
        "Vadodara",
        "Valsad"
    ]
},
{
    "stateName": "Haryana",
    "districtName": [
        "Ambala",
        "Bhiwani",
        "Faridabad",
        "Fatehabad",
        "Gurgaon",
        "Hissar",
        "Jhajjar",
        "Jind",
        "Karnal",
        "Kaithal",
        "Kurukshetra",
        "Mahendragarh",
        "Mewat",
        "Palwal",
        "Panchkula",
        "Panipat",
        "Rewari",
        "Rohtak",
        "Sirsa",
        "Sonipat",
        "Yamuna Nagar"
    ]
}, {
    "stateName": "Himachal Pradesh",
    "districtName": [
        "Bilaspur",
        "Chamba",
        "Hamirpur",
        "Kangra",
        "Kinnaur",
        "Kullu",
        "Lahaul and Spiti",
        "Mandi",
        "Shimla",
        "Sirmaur",
        "Solan",
        "Una"
    ]
},
{
    "stateName": "Jammu and Kashmir",
    "districtName": [
        "Anantnag",
        "Badgam",
        "Bandipora",
        "Baramulla",
        "Doda",
        "Ganderbal",
        "Jammu",
        "Kargil",
        "Kathua",
        "Kishtwar",
        "Kupwara",
        "Kulgam",
        "Leh",
        "Poonch",
        "Pulwama",
        "Rajauri",
        "Ramban",
        "Reasi",
        "Samba",
        "Shopian",
        "Srinagar",
        "Udhampur"
    ]
},

{
    "stateName": "Jharkhand",
    "districtName": [
        "Bokaro",
        "Chatra",
        "Deoghar",
        "Dhanbad",
        "Dumka",
        "East Singhbhum",
        "Garhwa",
        "Giridih",
        "Godda",
        "Gumla",
        "Hazaribag",
        "Jamtara",
        "Khunti",
        "Koderma",
        "Latehar",
        "Lohardaga",
        "Pakur",
        "Palamu",
        "Ramgarh",
        "Ranchi",
        "Sahibganj",
        "Seraikela Kharsawan",
        "Simdega",
        "West Singhbhum"
    ]
},
{
    "stateName": "Karnataka",
    "districtName": [
        "Bagalkot",
        "Bangalore Rural",
        "Bangalore Urban",
        "Belgaum",
        "Bellary",
        "Bidar",
        "Bijapur",
        "Chamarajnagar",
        "Chikkamagaluru",
        "Chikkaballapur",
        "Chitradurga",
        "Davanagere",
        "Dharwad",
        "Dakshina Kannada",
        "Gadag",
        "Gulbarga",
        "Hassan",
        "Haveri district",
        "Kodagu",
        "Kolar",
        "Koppal",
        "Mandya",
        "Mysore",
        "Raichur",
        "Shimoga",
        "Tumkur",
        "Udupi",
        "Uttara Kannada",
        "Ramanagara",
        "Yadgir"
    ]
},
{
    "stateName": "Kerala",
    "districtName": [
        "Alappuzha",
        "Ernakulam",
        "Idukki",
        "Kannur",
        "Kasaragod",
        "Kollam",
        "Kottayam",
        "Kozhikode",
        "Malappuram",
        "Palakkad",
        "Pathanamthitta",
        "Thrissur",
        "Thiruvananthapuram",
        "Wayanad"
    ]
},
{
    "stateName": "Madhya Pradesh",
    "districtName": [
        "Alirajpur",
        "Anuppur",
        "Ashok Nagar",
        "Balaghat",
        "Barwani",
        "Betul",
        "Bhind",
        "Bhopal",
        "Burhanpur",
        "Chhatarpur",
        "Chhindwara",
        "Damoh",
        "Datia",
        "Dewas",
        "Dhar",
        "Dindori",
        "Guna",
        "Gwalior",
        "Harda",
        "Hoshangabad",
        "Indore",
        "Jabalpur",
        "Jhabua",
        "Katni",
        "Khandwa (East Nimar)",
        "Khargone (West Nimar)",
        "Mandla",
        "Mandsaur",
        "Morena",
        "Narsinghpur",
        "Neemuch",
        "Panna",
        "Rewa",
        "Rajgarh",
        "Ratlam",
        "Raisen",
        "Sagar",
        "Satna",
        "Sehore",
        "Seoni",
        "Shahdol",
        "Shajapur",
        "Sheopur",
        "Shivpuri",
        "Sidhi",
        "Singrauli",
        "Tikamgarh",
        "Ujjain",
        "Umaria",
        "Vidisha"
    ]
},
{
    "stateName": "Maharashtra",
    "districtName": [
        "Ahmednagar",
        "Akola",
        "Amravati",
        "Aurangabad",
        "Bhandara",
        "Beed",
        "Buldhana",
        "Chandrapur",
        "Dhule",
        "Gadchiroli",
        "Gondia",
        "Hingoli",
        "Jalgaon",
        "Jalna",
        "Kolhapur",
        "Latur",
        "Mumbai City",
        "Mumbai suburban",
        "Nandurbar",
        "Nanded",
        "Nagpur",
        "Nashik",
        "Osmanabad",
        "Parbhani",
        "Pune",
        "Raigad",
        "Ratnagiri",
        "Sindhudurg",
        "Sangli",
        "Solapur",
        "Satara",
        "Thane",
        "Wardha",
        "Washim",
        "Yavatmal"
    ]
},
{
    "stateName": "Manipur",
    "districtName": [
        "Bishnupur",
        "Churachandpur",
        "Chandel",
        "Imphal East",
        "Senapati",
        "Tamenglong",
        "Thoubal",
        "Ukhrul",
        "Imphal West"
    ]
},
{
    "stateName": "Meghalaya",
    "districtName": [
        "East Garo Hills",
        "East Khasi Hills",
        "Jaintia Hills",
        "Ri Bhoi",
        "South Garo Hills",
        "West Garo Hills",
        "West Khasi Hills"
    ]
},
{
    "stateName": "Mizoram",
    "districtName": [
        "Aizawl",
        "Champhai",
        "Kolasib",
        "Lawngtlai",
        "Lunglei",
        "Mamit",
        "Saiha",
        "Serchhip"
    ]
},
{
    "stateName": "Nagaland",
    "districtName": [
        "Dimapur",
        "Kohima",
        "Mokokchung",
        "Mon",
        "Phek",
        "Tuensang",
        "Wokha",
        "Zunheboto"
    ]
},
{
    "stateName": "Orissa",
    "districtName": [
        "Angul",
        "Boudh (Bauda)",
        "Bhadrak",
        "Balangir",
        "Bargarh (Baragarh)",
        "Balasore",
        "Cuttack",
        "Debagarh (Deogarh)",
        "Dhenkanal",
        "Ganjam",
        "Gajapati",
        "Jharsuguda",
        "Jajpur",
        "Jagatsinghpur",
        "Khordha",
        "Kendujhar (Keonjhar)",
        "Kalahandi",
        "Kandhamal",
        "Koraput",
        "Kendrapara",
        "Malkangiri",
        "Mayurbhanj",
        "Nabarangpur",
        "Nuapada",
        "Nayagarh",
        "Puri",
        "Rayagada",
        "Sambalpur",
        "Subarnapur (Sonepur)",
        "Sundergarh"
    ]
},
{
    "stateName": "Pondicherry (Puducherry)",
    "districtName": [
        "Karaikal",
        "Mahe",
        "Pondicherry",
        "Yanam"
    ]
},
{
    "stateName": "Punjab",
    "districtName": [
        "Amritsar",
        "Barnala",
        "Bathinda",
        "Firozpur",
        "Faridkot",
        "Fatehgarh Sahib",
        "Fazilka",
        "Gurdaspur",
        "Hoshiarpur",
        "Jalandhar",
        "Kapurthala",
        "Ludhiana",
        "Mansa",
        "Moga",
        "Sri Muktsar Sahib",
        "Pathankot",
        "Patiala",
        "Rupnagar",
        "Ajitgarh (Mohali)",
        "Sangrur",
        "Nawanshahr",
        "Tarn Taran"
    ]
},
{
    "stateName": "Rajasthan",
    "districtName": [
        "Ajmer",
        "Alwar",
        "Bikaner",
        "Barmer",
        "Banswara",
        "Bharatpur",
        "Baran",
        "Bundi",
        "Bhilwara",
        "Churu",
        "Chittorgarh",
        "Dausa",
        "Dholpur",
        "Dungapur",
        "Ganganagar",
        "Hanumangarh",
        "Jhunjhunu",
        "Jalore",
        "Jodhpur",
        "Jaipur",
        "Jaisalmer",
        "Jhalawar",
        "Karauli",
        "Kota",
        "Nagaur",
        "Pali",
        "Pratapgarh",
        "Rajsamand",
        "Sikar",
        "Sawai Madhopur",
        "Sirohi",
        "Tonk",
        "Udaipur"
    ]
},
{
    "stateName": "Sikkim",
    "districtName": [
        "East Sikkim",
        "North Sikkim",
        "South Sikkim",
        "West Sikkim"
    ]
},

{
    "stateName": "Telangana",
    "districtName" :["Adilabad",
                    "Bhadradri Kothagudem",
                    "Hyderabad",
                    "Jagtial",
                    "Jangaon",
                   "Jayashankar Bhoopalpally",
                    "Jogulamba Gadwal",
                   "Kamareddy",
                    "Karimnagar",
                    "Khammam",
                    "Komaram Bheem Asifabad",
                    "Mahabubabad",
                    "Mahabubnagar",
                    "Mancherial",
                    "Medak",
                    "Medchal",
                    "Nagarkurnool",
                    "Nalgonda",
                    "Nirmal",
                    "Nizamabad",
                    "Peddapalli",
                    "Rajanna Sircilla",
                    "Rangareddy",
                    "Sangareddy",
                    "Siddipet",
                    "Suryapet",
                    "Vikarabad",
                    "Wanaparthy",
                    "Warangal (Rural)",
                    "Warangal (Urban)",
                    "Yadadri Bhuvanagiri"
                ]
},
{
    "stateName": "Tamil Nadu",
    "districtName": [
        "Ariyalur",
        "Chennai",
        "Coimbatore",
        "Cuddalore",
        "Dharmapuri",
        "Dindigul",
        "Erode",
        "Kanchipuram",
        "Kanyakumari",
        "Karur",
        "Madurai",
        "Nagapattinam",
        "Nilgiris",
        "Namakkal",
        "Perambalur",
        "Pudukkottai",
        "Ramanathapuram",
        "Salem",
        "Sivaganga",
        "Tirupur",
        "Tiruchirappalli",
        "Theni",
        "Tirunelveli",
        "Thanjavur",
        "Thoothukudi",
        "Tiruvallur",
        "Tiruvarur",
        "Tiruvannamalai",
        "Vellore",
        "Viluppuram",
        "Virudhunagar"
    ]
},
{
    "stateName": "Tripura",
    "districtName": [
        "Dhalai",
        "North Tripura",
        "South Tripura",
        "Khowai",
        "West Tripura"
    ]
},
{
    "stateName": "Uttar Pradesh",
    "districtName": [
        "Agra",
        "Allahabad",
        "Aligarh",
        "Ambedkar Nagar",
        "Auraiya",
        "Azamgarh",
        "Barabanki",
        "Budaun",
        "Bagpat",
        "Bahraich",
        "Bijnor",
        "Ballia",
        "Banda",
        "Balrampur",
        "Bareilly",
        "Basti",
        "Bulandshahr",
        "Chandauli",
        "Chhatrapati Shahuji Maharaj Nagar",
        "Chitrakoot",
        "Deoria",
        "Etah",
        "Kanshi Ram Nagar",
        "Etawah",
        "Firozabad",
        "Farrukhabad",
        "Fatehpur",
        "Faizabad",
        "Gautam Buddh Nagar",
        "Gonda",
        "Ghazipur",
        "Gorakhpur",
        "Ghaziabad",
        "Hamirpur",
        "Hardoi",
        "Mahamaya Nagar",
        "Jhansi",
        "Jalaun",
        "Jyotiba Phule Nagar",
        "Jaunpur district",
        "Ramabai Nagar (Kanpur Dehat)",
        "Kannauj",
        "Kanpur",
        "Kaushambi",
        "Kushinagar",
        "Lalitpur",
        "Lakhimpur Kheri",
        "Lucknow",
        "Mau",
        "Meerut",
        "Maharajganj",
        "Mahoba",
        "Mirzapur",
        "Moradabad",
        "Mainpuri",
        "Mathura",
        "Muzaffarnagar",
        "Panchsheel Nagar district (Hapur)",
        "Pilibhit",
        "Shamli",
        "Pratapgarh",
        "Rampur",
        "Raebareli",
        "Saharanpur",
        "Sitapur",
        "Shahjahanpur",
        "Sant Kabir Nagar",
        "Siddharthnagar",
        "Sonbhadra",
        "Sant Ravidas Nagar",
        "Sultanpur",
        "Shravasti",
        "Unnao",
        "Varanasi"
    ]
},
{
    "stateName": "Uttarakhand",
    "districtName": [
        "Almora",
        "Bageshwar",
        "Chamoli",
        "Champawat",
        "Dehradun",
        "Haridwar",
        "Nainital",
        "Pauri Garhwal",
        "Pithoragarh",
        "Rudraprayag",
        "Tehri Garhwal",
        "Udham Singh Nagar",
        "Uttarkashi"
    ]
},
{
    "stateName": "West Bengal",
    "districtName": [
        "Birbhum",
        "Bankura",
        "Bardhaman",
        "Darjeeling",
        "Dakshin Dinajpur",
        "Hooghly",
        "Howrah",
        "Jalpaiguri",
        "Cooch Behar",
        "Kolkata",
        "Maldah",
        "Paschim Medinipur",
        "Purba Medinipur",
        "Murshidabad",
        "Nadia",
        "North 24 Parganas",
        "South 24 Parganas",
        "Purulia",
        "Uttar Dinajpur"
    ]
}
]
  export interface Bank {
    id: string;
    name: string;
  }